import classNames from "classnames";
import "./index.scss";

interface IProps {
  isExpand: boolean;
  onClick: (type: string) => void;
  iconType: string;
  theme?: "light" | "dark"
}

export const StudyPlannerContentNotExpandIcon = ({
  isExpand,
  onClick,
  iconType,
  theme
}: IProps) => {
  return (
    <div
      className={classNames("expand-icon-wrapper", { expanded: isExpand })}
      onClick={() => onClick(iconType)}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M7.5 15L12.5 10L7.5 5"
          stroke={theme === "light" ? "black" : "white"}
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};
